export default __webpack_public_path__ + "static/media/sale-man.f0366d06.png";